import { createFileRoute } from "@tanstack/react-router";

import { RecentTransactionPage } from "@/app/pages/RecentTransactionPage";
import { EmptyState } from "@/components/EmptyState/EmptyState";
import { getCookies, COOKIE_KEYS } from "@/helpers/cookie";
import { expensesEffectAtom, expensesAtom } from "@/store/global";
import { useAtom } from "jotai";
import { nanoid } from "nanoid";

export const Route = createFileRoute("/_recent")({
  component: RecentTransactionLayout,
});

function RecentTransactionLayout() {
  useAtom(expensesEffectAtom);

  const [{ expenses }, setExpenses] = useAtom(expensesAtom);
  const displayableExpenses = expenses.filter((expense) => !expense?.deleted);

  /** Assign ID for fallback purposes */
  const expensesShouldSetIdIndex = displayableExpenses.reduce((acc, curr, index) => {
    if (!curr?.id) return [...acc, index];

    return acc;
  }, [] as number[]);

  expensesShouldSetIdIndex.forEach((index) => {
    setExpenses((draft) => {
      draft.expenses[index].id = nanoid();
    });
  });
  /** End - Assign ID for fallback purposes */

  const cookie = getCookies();

  if (displayableExpenses.length > 0 || cookie.get(COOKIE_KEYS.HAS_EXPENSES) === "1") {
    return <RecentTransactionPage />;
  } else if (cookie.get(COOKIE_KEYS.HAS_EXPENSES) === "0" || !cookie.has(COOKIE_KEYS.HAS_EXPENSES)) {
    return <EmptyState />;
  }
}
